// extracted by mini-css-extract-plugin
module.exports = {"root":"EventGroupListingPage_root__48ehk"};